import React, { FunctionComponent } from 'react';

import { SvgProps, propsHelperRem } from '@/shared/lib/propsHelper';

export const VolumeMuted: FunctionComponent<SvgProps> = (props) => (
    <svg {...propsHelperRem(2.4, 2.4, props)}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 8.5 12.5 4v16L6 15.5H2.5v-7H6Zm10.393 7.493 2.296-2.296 2.296 2.296 1.698-1.697L20.386 12l2.297-2.296-1.698-1.697-2.296 2.296-2.296-2.296-1.697 1.697L16.992 12l-2.296 2.296 1.697 1.697Z"
            fill="#fff"
        />
    </svg>
);
